import { render, staticRenderFns } from "./relation-trajectory-enrolments.vue?vue&type=template&id=a11e37ca"
import script from "./relation-trajectory-enrolments.vue?vue&type=script&lang=js"
export * from "./relation-trajectory-enrolments.vue?vue&type=script&lang=js"
import style0 from "./relation-trajectory-enrolments.vue?vue&type=style&index=0&id=a11e37ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports